module.exports = __webpack_public_path__ + "media/images/equipments-img-01-1cba71952b801b213614dca56b544a71.png";